import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import { makeStyles } from "tss-react/mui"

import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { LabeledField } from "../../../../../../shared/components/forms/LabeledField"

import { ALL_RESOURCE_TYPES, DASHBOARD_RESOURCE_TYPES, ResourceTypeSelection } from "./resourceDashboardTypes"

type ResourceTypeSelectionFilterProps = Readonly<{
    value: ResourceTypeSelection
    onChange: (value: ResourceTypeSelection) => void
}>

const useStyles = makeStyles()((theme) => ({
    field: {
        width: "15rem",
    },
    select: {
        borderRadius: ".75rem",
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.tailwind.slate[300],
        },
    },
}))

export function ResourceTypeSelectionFilter({ value, onChange }: ResourceTypeSelectionFilterProps) {
    const { classes } = useStyles()

    return (
        <LocalizedStrict id="table-select-resource-type-filter-by-label-label" attrs={{ label: true }}>
            <LabeledField label="Resource type" bold={false} gap=".25rem" className={classes.field}>
                <Select
                    id="resource-dashboard-resource-type-select"
                    value={value}
                    onChange={(event) => onChange(event.target.value as ResourceTypeSelection)}
                    className={classes.select}
                    fullWidth
                >
                    <MenuItem value={ALL_RESOURCE_TYPES}>
                        <LocalizedStrict id="resource-dashboard-type-all">
                            <span>All types</span>
                        </LocalizedStrict>
                    </MenuItem>
                    {DASHBOARD_RESOURCE_TYPES.map((resourceType) => (
                        <MenuItem key={resourceType} value={resourceType}>
                            <LocalizedEnum base="resource-dashboard-type" enumValue={resourceType}>
                                <span>{resourceType}</span>
                            </LocalizedEnum>
                        </MenuItem>
                    ))}
                </Select>
            </LabeledField>
        </LocalizedStrict>
    )
}
